import { Button } from '@bowtie-ins/bowkit';
import { Box } from '@material-ui/core';
import { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { COMPARISON_PAGE_URLS_LANG_MAPPING } from '../../constants';
import { QuotationContextValue } from '../../contexts/QuotationContext';
import { getPlanDetailsUrl } from '../../helpers/queryparam';

type Props = Pick<QuotationContextValue, 'activeProduct'> & {
  formValues: QuotationContextValue['values'];
  disabled?: boolean;
  variant: 'cta-only' | 'plans-comparison' | 'plan-detail';
  size: 'small' | 'large';
  onClick?: () => void;
};

const ActionPanel = ({
  formValues,
  disabled,
  activeProduct,
  variant,
  size,
  onClick,
}: Props) => {
  const intl = useIntl();
  const planDetailsUrl = useMemo(() => {
    if (!activeProduct) {
      return '';
    }

    return variant === 'plans-comparison'
      ? COMPARISON_PAGE_URLS_LANG_MAPPING[intl.locale]
      : getPlanDetailsUrl(activeProduct.plan_details_url, formValues);
  }, [activeProduct, formValues, intl.locale, variant]);

  return (
    <Box
      display="flex"
      gridGap={24}
      justifyContent="space-between"
      alignItems="center"
      flexDirection={size === 'small' ? 'column' : 'row'}
    >
      {variant !== 'cta-only' && (
        <Button
          as="a"
          id="plan-details"
          href={planDetailsUrl}
          target="_blank"
          color="secondary"
          variant="contained"
          size="l"
          fullWidth
          disabled={!planDetailsUrl}
          data-ui-component="Button"
          data-ui-variant="Details"
        >
          <FormattedMessage
            id={variant === 'plans-comparison' ? 'comparePlans' : 'planDetails'}
          />
        </Button>
      )}
      <Button
        as="a"
        id="application"
        onClick={onClick}
        color="primary"
        variant="contained"
        size="l"
        fullWidth
        disabled={disabled}
        data-ui-component="Button"
        data-ui-variant="Submit"
      >
        <FormattedMessage id="apply" />
      </Button>
    </Box>
  );
};

export default ActionPanel;
